import EventEmitter from './EventEmitter';
import { MOBILE_BREAKPOINT } from '../World/deskSceneConfig';
function getViewportSize() {
    const vv = typeof window !== 'undefined' && window.visualViewport;
    if (vv && Number.isFinite(vv.width) && Number.isFinite(vv.height)) {
        return { width: vv.width, height: vv.height };
    }
    return {
        width: typeof window !== 'undefined' ? window.innerWidth : 1024,
        height: typeof window !== 'undefined' ? window.innerHeight : 768,
    };
}
export default class Sizes extends EventEmitter {
    constructor() {
        super();
        const size = getViewportSize();
        this.width = size.width;
        this.height = size.height;
        this.pixelRatio = Math.min(typeof window !== 'undefined' ? window.devicePixelRatio : 1, 2);
        const updateSizes = () => {
            const s = getViewportSize();
            this.width = s.width;
            this.height = s.height;
            this.pixelRatio = Math.min(typeof window !== 'undefined' ? window.devicePixelRatio : 1, 2);
            this.trigger('resize');
        };
        window.addEventListener('resize', updateSizes);
        window.addEventListener('orientationchange', updateSizes);
        const vv = window.visualViewport;
        if (vv && typeof vv.addEventListener === 'function') {
            vv.addEventListener('resize', updateSizes);
        }
        // When media queries change (e.g. orientation), refresh dimensions so camera/keyframes see it
        const mqMobile = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
        const mqPortrait = window.matchMedia('(orientation: portrait)');
        mqMobile.addEventListener('change', updateSizes);
        mqPortrait.addEventListener('change', updateSizes);
        // Mobile often reports wrong size on first paint; re-read after viewport settles
        const recheck = () => updateSizes();
        requestAnimationFrame(recheck);
        setTimeout(recheck, 50);
        setTimeout(recheck, 200);
    }
    isMobile() {
        if (typeof window === 'undefined')
            return this.width < MOBILE_BREAKPOINT;
        return window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`).matches;
    }
    isMobilePortrait() {
        if (typeof window === 'undefined')
            return this.width < MOBILE_BREAKPOINT && this.height > this.width;
        const mobile = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`).matches;
        const portrait = window.matchMedia('(orientation: portrait)').matches || (mobile && this.height > this.width);
        return mobile && portrait;
    }
    isMobileLandscape() {
        if (typeof window === 'undefined')
            return this.width < MOBILE_BREAKPOINT && this.width > this.height;
        const mobile = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`).matches;
        const landscape = window.matchMedia('(orientation: landscape)').matches || (mobile && this.width > this.height);
        return mobile && landscape;
    }
}
